<!--
 * @Author: Src
 * @Date: 2025-08-08 13:36:31
 * @LastEditTime: 2026-06-11 13:46:41
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/car/vmDetaile.vue
 * @Description: 头部注释配置模板
-->
<template>
  <div class="car_detaile">
    <div v-if="!loading">
      <div v-if="!showImg">
        <div>
          <div class="top_swipe">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="white"
              :show-indicators="false"
              @change="changeIndex"
            >
              <van-swipe-item v-for="(item, index) in shopImg" :key="index">
                <div
                  style="
                    width: 100%;
                    padding-top: 75%;
                    position: relative;
                    overflow: hidden;
                  "
                >
                  <img
                    :src="item"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    "
                    @click="showImg = true"
                  />
                </div>
              </van-swipe-item>
            </van-swipe>
            <span class="swipe_span">
              {{ `${shopImgIndex}/${shopImg.length}` }}
            </span>
          </div>
        </div>
        <div
          style="
            padding-bottom: 80px;
            margin-top: -20px;
            width: 100%;
            position: relative;
            background: #f6f7f8;
          "
        >
          <div
            style="
              position: absolute;
              background: #f6f7f8;
              top: -10px;
              width: 100%;
            "
          >
            <div class="car_body car_bodytitle">
              <div class="car_name">{{ commodity.name }}</div>
              <div class="car_price">
                <div class="_price" style="color: #804242">
                  <span>{{ commodity.price }} </span>
                </div>
                <div class="market_price">
                  <span>{{ commodity.market_price }} </span>
                </div>
              </div>
              <div class="vm_tag">
                <span
                  v-for="(item, index) in commodity.tags"
                  :key="index"
                  class="item_tag"
                >
                  {{ item.tag }}</span
                >
              </div>
            </div>

            <div id="captcha-element"></div>
          </div>
        </div>
        <div class="vm_body">
          <div v-html="commodity.description" class="html-content"></div>
        </div>
      </div>

      <div v-else>
        <viewImage
          v-show="showImg"
          :imgList="commodity.car_images"
          :shopImg="shopImg"
          :name="commodity.name"
          :pice="commodity.price"
          @close="showImg = false"
        ></viewImage>
      </div>
    </div>
    <div v-loading="loading"></div>

    <buttonPopup v-show="show">
      <div class="popup_class">
        咨询价格优惠
        <div class="van_icon">
          <i class="van-icon van-icon-cross" @click="closePopup"></i>
        </div>
      </div>
      <div class="popup_body">
        <div class="body_top">
          <div class="top_img">
            <img :src="shopImg[0]" style="width: 60px; height: 50px" />
          </div>
          <div>
            <div class="popupcar_name">{{ commodity.name }}</div>
          </div>
        </div>
        <div class="body_phone">
          <mt-field
            label="手机号"
            placeholder="请输入手机号"
            v-model="formData.mobile"
            type="tel"
          ></mt-field>
        </div>
        <div class="body_phone">
          <!-- <el-input></el-input> -->
          <mt-field
            label="验证码"
            placeholder="请输入验证码"
            v-model="formData.captcha"
            type="tel"
            :attr="{ maxlength: 6 }"
          >
            <div id="captcha-button">
              <span v-if="formData.mobile.length == 11 && !isCountingDown">
                {{ getAuthCodeTxt }}</span
              >
            </div>
            <div v-if="formData.mobile.length == 11 && isCountingDown">
              <span> {{ getAuthCodeTxt }}</span>
            </div>
          </mt-field>
        </div>
      </div>
      <div class="popup_btn">
        <div class="popup_button" @click="submitBar">咨询底价</div>
      </div>
      <div class="popup_bt_lalst">
        <div class="popup_checkbox">
          <el-checkbox v-model="checked"
            >阅读并同意<a
              href="https://cache.gaode.com/activity/lowcode/h5/pAuviELd/index.html"
              target="_blank"
              style="color: #1a66ff; font-size: 12px"
              >《咨询服务个人信息处理规则》</a
            ></el-checkbox
          >
        </div>
      </div>
    </buttonPopup>

    <!-- <div id="captcha-button">点击弹出验证码A</div> -->
    <div id="captcha-element"></div>
    <van-tabbar v-model="active">
      <div class="footer_tabbar" :class="showImg ? 'b_color' : ''">
        <div class="tannar_item_x1">
          <button
            class="van-button van-button--default van-button--normal h_54 bu-l"
            @click="openPopup('1', 'InquireAboutTheMinimumPrice')"
          >
            <span class="van-button__content">咨询商品</span>
          </button>
        </div>
        <div class="tannar_item_x1">
          <button
            class="van-button van-button--info van-button--normal h_54"
            @click="makeCall('ContactTheSeller')"
          >
            <span class="van-button__content">联系卖家</span>
          </button>
        </div>
      </div>
    </van-tabbar>
  </div>
</template>

<script lang="ts">
import {
  Swipe,
  SwipeItem,
  Popup,
  Tabbar,
  Icon,
  Button,
  SubmitBar,
  Checkbox,
  CheckboxGroup,
} from 'vant';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

import buttonPopup from './components/buttonPopup.vue';
import viewImage from './components/viewImage.vue';

import { Toast } from 'mint-ui';

@Component({
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tabbar.name]: Tabbar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    buttonPopup,
    viewImage,
  },
})
export default class vmDetaile extends Vue {
  @lazyInject(CarService)
  protected carService!: CarService;

  commodity: any = {
    transfer_times: 0,
    mileage: 0,
    highlights: [],
  };

  shop: any = {};

  model: any = {};

  active = 'home';

  mobile = '';

  checked = true;

  username = '';

  formData: any = {
    mobile: '',
    captcha: '',
  };

  captcha = '';

  captchaButton: any = null;

  paraType = true;

  archiveType = true;

  from = '';

  heightType = true;

  shopImg: any = [];

  carShow = false;

  carType = false; // false 代表纯电车

  loading = true;

  showImg = false;

  shopImgIndex = 1;

  'car_images' = [];

  changeShow() {
    this.carShow = !this.carShow;
  }

  get imgList() {
    if (!this.commodity.car_images) {
      return [];
    }
    const list = JSON.parse(JSON.stringify(this.commodity.car_images));
    return list.slice(0, 4);
  }

  get address() {
    let add: any =
      this.shop.province +
      this.shop.city +
      this.shop.district +
      this.shop.address;
    if (this.shop.province === this.shop.city) {
      add = this.shop.city + this.shop.district + this.shop.address;
    }
    return add ? add : '--';
  }

  get firstRegistrationDate() {
    console.log(this.model);
    if (!this.commodity.first_registration_date) {
      return '--';
    }
    const date = this.commodity.first_registration_date;

    return `${date.slice(0, 4)}-${date.slice(5, 7)}`;
  }

  get yearDate() {
    if (!this.commodity.first_registration_date) {
      return '--';
    }
    const date = this.commodity.first_registration_date;
    return `${date.slice(0, 4)}年`;
  }

  gearName(val: any) {
    if (val) {
      return val.replace(/\s/g, '');
    } else {
      return '--';
    }
  }

  changeIndex(index: number) {
    this.shopImgIndex = index + 1;
  }
  cddsdfsdf() {
    const { aplus_queue } = window;
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [
        {
          is_auto: false,
        },
        {
          param: this.commodity_code,
        },
      ],
    });
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        'accessInformation',
        'EXP',
        {
          param: this.commodity_code,
        },
      ],
    });
  }

  getPrice() {
    const price =
      (this.model.official_price ? Number(this.model.official_price) : 0) +
      (this.model.tax ? Number(this.model.tax) : 0);
    return price.toFixed(2);
  }

  async getCarDetail(code: any) {
    const res = await this.carService.getVmDetail({ code });
    if (res) {
      const { commodity, token } = res;
      this.shopImg = commodity.images.map((item: any) => item.url);
      this.commodity = commodity;
      this.token = token;
      this.loading = false;
    }
  }

  show = false;

  openPopup(val: any, type: any) {
    this.from = val;
    this.show = true;
    const { aplus_queue } = window;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        type,
        'CLK',
        {
          param: this.commodity_code,
        },
      ],
    });
  }

  phoneNumber = '';

  token = '';

  async makeCall(type: any) {
    const { aplus_queue } = window;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        type,
        'CLK',
        {
          param: this.commodity_code,
        },
      ],
    });
    // 在方法中触发，可以添加逻辑，如埋点、验证等
    const res = await this.carService.postQueryPhone({
      shop_code: this.commodity.car_shop_code,
      token: this.token,
    });
    if (res) {
      this.phoneNumber = res.phone;
      window.location.href = `tel:${this.phoneNumber}`;
    }
  }

  commodity_code = '';

  async mounted() {
    const { id } = this.$route.params;
    this.commodity_code = id;
    await this.getCarDetail(id);
    this.captchaButton = document.getElementById('captcha-button');
    this.initCaptcha();
    // this.loadAmapScript();
    this.initAplus();
    this.cddsdfsdf();
  }

  private initAplus(): void {
    const w = window as any;
    const d = document;
    const s = 'script';
    const q = 'aplus_queue';
    const i = '203467608';

    // 确保 aplus_queue 数组存在
    if (!w[q]) {
      w[q] = [];
    }

    // 创建并插入 Aplus 主库脚本
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    j.async = true;
    j.id = 'beacon-aplus';
    j.src = `https://d.alicdn.com/alilog/mlog/aplus/${i}.js`;

    // 防止重复插入
    // if (!d.getElementById('beacon-aplus')) {
    //   f.parentNode.insertBefore(j, f);
    // }

    // 配置 SDK
    this.configureAplus();
  }
  private configureAplus(): void {
    const { aplus_queue } = window as any;
console.log(aplus_queue);
    // 设置 AppKey
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', '6a2a25496f259537c7b73c4f'],
    });

    // 调试模式
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['DEBUG', true],
    });

    // 手动 PV 模式（SPA 推荐）
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-waiting', 'MAN'],
    });
  }

  getInstance(instance: any) {
    this.captcha = instance;
  }

  closePopup() {
    this.show = false;
    clearInterval(this.timer);
    this.getAuthCodeTxt = '获取验证码';
    this.isCountingDown = false;
    this.formData = {
      mobile: '',
      captcha: '',
    };
  }
  private timer?: number;
  isCountingDown = false;
  getAuthCodeTxt = '获取验证码';

  async success(captchaVerifyParam: any) {
    // 入参为验签captchaVerifyParam
    // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
    // 2.根据校验结果来进行业务处理
    // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
    // console.log(captchaVerifyParam);
    const { aplus_queue } = window;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        'GetVerificationCode',
        'CLK',
        {
          param: this.commodity_code,
        },
      ],
    });
    const data = {
      mobile: this.formData.mobile,
      verify_token: captchaVerifyParam,
    };
    this.initCaptcha();

    const res = await this.carService.postSengCaptcha(data);
    if (res) {
      this.funCountingDown();
    }
  }
  funCountingDown() {
    if (this.isCountingDown) {
      return;
    }

    this.isCountingDown = true;
    let seconds = 60;
    this.timer = setInterval(() => {
      seconds -= 1;
      if (seconds > 0) {
        this.getAuthCodeTxt = `${seconds}S`;
      } else {
        clearInterval(this.timer);
        this.isCountingDown = false;
        this.getAuthCodeTxt = '请重新获取';
      }
      // this.updateSendable();
    }, 1000);
  }

  async submitBar() {
    if (!this.checked) {
      Toast({
        message: '请勾选阅读并同意《咨询服务个人信息处理规则》',
        type: 'fail',
      });
      return;
    }
    const { aplus_queue } = window;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        'ConsultationSubmission',
        'CLK',
        {
          param: this.commodity_code,
        },
      ],
    });
    const { mobile, captcha } = this.formData;
    if (!mobile || !captcha) {
      Toast({
        message: '请填写完整信息',
        type: 'fail',
      });
      return;
    }
    const data = {
      mobile,
      captcha,
      //   from: this.from,
      commodity_code: this.commodity_code,
    };
    const res = await this.carService.postVmAssetSave(data);
    if (res) {
      this.closePopup();
    }
  }

  // 验证码验证不通过回调函数
  fail(error: any) {
    console.error(error);
  }
  initCaptcha() {
    window.initAliyunCaptcha({
      SceneId: '1846it7k', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#captcha-button', // 触发验证码弹窗的元素。
      success: this.success,
      fail: this.fail,
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  }

  private scriptLoaded = false;

  beforeDestroy() {
    // 可选：移除脚本或清理
  }

  loadAmapScript() {
    if (window.AmapApp) {
      this.scriptLoaded = true;
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://cache.amap.com/activity/amap-lib-tripartite-1.2.0/js/amapLib.js';
    script.onload = () => {
      console.log('amapLib.js loaded');
      this.scriptLoaded = true;
      // 可选：触发 ready 回调
      if (window.AmapApp?.bridge?.ready) {
        window.AmapApp.bridge.ready(() => {
          console.log('AmapApp bridge ready');
        });
      }
    };
    script.onerror = () => {
      console.error('Failed to load amapLib.js');
    };
    document.head.appendChild(script);
  }

  onGetAmapAuthCode() {
    console.log('onGetAmapAuthCode');
    if (!this.scriptLoaded || !window.AmapApp?.bridge?.send) {
      alert('高德 SDK 尚未加载完成，请稍后再试');
      return;
    }
    console.log('window.AmapApp', window.AmapApp);
    const appId = '2019102468561705';
    const scopes = ['auth_base', 'auth_user', 'auth_phone'];

    window.AmapApp.bridge.send(
      {
        action: 'getAmapAuthCode',
        appId,
        scopes,
      },
      (res: any) => {
        console.log('Auth response:', res);
        alert(`onGetAmapAuthCode: ${JSON.stringify(res)}`);
      },
    );
  }
}
</script>
<style scoped lang="scss">
.car_detaile {
  background: #f6f7f8;
  padding-bottom: 80px;
  height: auto;
  // height: calc(100h - 80px);
  // overflow: hidden;

  ol {
    list-style-type: decimal !important;
    padding-left: 1.5em;
  }
  ul {
    list-style-type: disc !important;
    padding-left: 1.5em;
  }
  li {
    display: list-item !important;
    text-align: -webkit-match-parent;
  }

  .top_swipe {
    position: relative;
    width: 100vw;

    .swipe_span {
      position: absolute;
      box-sizing: border-box;
      padding: 5px 10px;
      bottom: 40px;
      right: 10px;
      color: #fff;
      font-size: 12px;
      z-index: 8;
      background: fixed rgba(0, 0, 0, 0.5);
    }
  }

  // height: 100vh;
  .top_class {
    margin: 10px;
    padding: 10px;

    ._price {
      font-size: 14px;
      color: #ea553f;

      span {
        font-size: 24px;
        font-weight: bold;
      }
    }

    .price_info {
      margin-top: 20px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .container::before {
    content: '';
    display: block;
    padding-top: 120px;
    /* 9 / 16 = 0.5625 → 56.25% */
  }

  .car_bodytitle {
    margin: 0px !important;
    border-radius: 10px 10px 0px 0px !important;
    padding: 20px 20px !important;
  }

  .car_body {
    margin: 10px;
    padding: 20px 10px;
    background: #fff;
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    .car_title {
      font-size: 14px;
      font-weight: 600;
      position: relative;
      color: rgba(0, 0, 0, 0.9);

      // padding-bottom: 10px;

      .class_type {
        position: absolute;
        top: 0px;
        right: 10px;
        font-size: 12px !important;
        font-weight: 200;
        color: rgba(0, 0, 0, 0.4);

        img {
          width: 12px;
        }

        .class_span {
          font-size: 12px;
        }
      }

      .button_call {
        position: absolute;
        right: 0;
        top: -10px;

        .call-button {
          border-radius: 4px;
          // background: #142273F7;
          width: 80px;
          height: 28px;
          font-size: 12px !important;
          font-weight: 500;
          // padding: 4px 8px;
          background: rgba(34, 115, 247, 0.08);
          color: #2273f7;
          border: none;
        }
      }
    }

    .shop_bdy {
      display: flex;
      margin-top: 10px;

      .shop_img {
        border-radius: 8px;
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
          width: 100px;
          height: 100px;
        }
      }

      .shop_text {
        margin: 0 12px;
        margin-bottom: 10px;
        flex: 1;

        .shop_name {
          font-size: 16px;
          font-weight: 600;
          color: #333;

          img {
            width: 15px;
          }
        }

        .shop_next {
          font-size: 12px;
          color: #67676e;
          margin: 5px 0;
        }

        .call-button {
          background: #1a66ff;
          color: #fff;
          padding: 6px 8px;
          font-size: 12px;
          border: none;
          // width: 110px;
          width: 100%;
          border-radius: 4px;
        }
      }
    }

    .car_tag_box {
      margin-top: 20px;

      .car_tag {
        color: #67676e;
        box-sizing: border-box;
        background: #f4f5f8;
      }
    }

    .car_name {
      font-size: 18px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: normal;
    }

    .car_price {
      position: relative;
      font-size: 18px;
      display: flex;
      gap: 10px;
      align-items: flex-end;

      .button_call {
        position: absolute;
        right: 0;
        top: 0;

        .call-button {
          background: #1a66ff;
          width: 80px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          border: none;
          border-radius: 4px;
        }
      }

      ._price {
        font-size: 14px;
        color: #ea553f;

        span {
          font-size: 28px;
          font-weight: bold;
        }
      }
      .market_price {
        font-size: 12px;
        color: #67676e;
        text-decoration: line-through;
        margin-left: 10px;
        padding-bottom: 5px;
      }

      .price_info {
        font-size: 12px;
        color: #67676e;
        margin: 5px 0;
      }
    }

    .vm_tag {
      font-size: 12px;
      color: #67676e;
      margin: 5px 0;
      .item_tag {
        margin-right: 10px;
        padding: 5px 10px;
        margin: 5px;
        background: #d3eef3;
        color: #5bb2e8;
        border-radius: 8px;
        display: inline-block;
      }
    }

    .car_text {
      white-space: pre-line;

      position: relative;

      .car_span {
        font-size: 10px;
        padding: 10px 5px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.4);
        z-index: 3;
        padding-top: 15px;
        line-height: 15px;
      }

      .text_img {
        position: absolute;
        top: 0;
        left: -5px;
        z-index: 1;
        width: 28px;
        height: 25px;
      }
    }

    .car_listrad {
      border-radius: 10px;
      background: #f6f7f9;
    }

    .body_text {
      padding: 12px;
    }

    .highli_height {
      width: 100%;
      height: 61px;
      overflow: hidden;
    }

    .car_list {
      display: flex;
      flex-wrap: wrap;

      margin: 10px 0;

      .car_card {
        width: 50%;
        margin-bottom: 10px;

        .card_left {
          color: #a0a0a7;
          font-size: 13px !important;
        }

        .card_right {
          padding: 5px 10px;
          font-size: 13px !important;
          color: #23242e;
        }
      }

      .car_cardflex {
        width: 100% !important;
      }

      .car_highli {
        width: 25%;
        padding: 5px;
        box-sizing: border-box;
        font-size: 12px !important;
        display: flex;
        flex-direction: column;
        align-items: center;

        .car_highli_icon {
          width: 21px;
        }

        .car_span {
          box-sizing: border-box;
          text-align: center;
          height: 30px;
          font-size: 11px !important;
          text-align: center;
          letter-spacing: normal;
          color: #000000;
        }
      }

      .list_item {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 10px 0;

        .item_res {
          width: 25%;
          text-align: center;
          border-right: 1px solid #e1e4e9;
          display: flex;
          flex-direction: column;

          .res_content {
            font-size: 12px;
            box-sizing: border-box;
            font-weight: 600;
            min-height: 20px;
            line-height: 20px;
            font-weight: bold;
          }

          .res_title {
            color: #9f9fa0;
            font-size: 11px;
          }
        }

        s .item_res:nth-child(4n) {
          border: none;
        }

        .item_res:last-child {
          border: none;
        }
      }
    }

    .car_list_box {
      width: 100%;
      height: 140px;
      overflow: hidden;
    }

    .car_more {
      text-align: center;
    }

    .car_img {
      .head_img {
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 8px;
        margin-top: 10px;
      }

      .body_mg {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 7px;
        margin-bottom: 12px;

        .in_img {
          // width: 48%;
          flex: 1;
          flex: 0 0 calc(50% - 3.5px);
          position: relative;
          box-sizing: border-box;
          // padding: 10px;
          border-radius: 10px;
          height: 140px;
          overflow: hidden;

          .class_look {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            font-size: 14px;
            border-radius: 10px;

            img {
              width: 12px;
            }

            .arrow_right {
              padding: 5px 10px;
              box-sizing: border-box;
              border-radius: 8px;
              background: rgba(0, 0, 0, 0.2);
            }
          }
        }
      }
    }
  }
  .vm_body {
    padding: 10px;
    padding-top: 80px;
  }

  .m-b-12 {
    padding-bottom: 12px !important;
  }

  .bottm_img {
    text-align: center;

    .text_img {
      width: 100%;
    }
  }

  .m-b-80 {
    margin-bottom: 80px;
  }

  .fs-18 {
    font-size: 14px;
  }

  .footer_tabbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100vw;
    height: 80px;
    gap: 8px;
    padding: 0 10px;

    // background: #f00;
    .tannar_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      flex: 0.5;

      img {
        width: 18px;
        height: 18px;
      }
    }

    .tannar_item_x1 {
      flex: 1;
    }

    .h_54 {
      height: 48px;
      width: 100%;
      font-size: 16px;
      border-radius: 5px;
    }

    .bu-l {
      background: #f0f5ff;
      color: #1a66ff;
      font-weight: bold;
    }
  }

  .b_color {
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
    border: none;
    border-color: #f00;
  }

  .popup_class {
    position: relative;
    padding: 12px 20px;
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.9);

    .van_icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .popup_body {
    padding: 10px;
    margin: 10px;
    font-size: 14px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    .body_top {
      display: flex;
      // box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      padding: 10px;
      border-radius: 5px;
      background: rgba(65, 88, 134, 0.04);
      .top_img {
        margin-right: 10px;
        width: 64px;
        height: 48px;
        border-radius: 5px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .popupcar_name {
        font-size: 16px;
        font-weight: 600;
      }

      .popup_price {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        margin-top: 10px;
      }
    }

    .body_phone {
      // margin-top: 20px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;

      #captcha-button {
        color: #1a66ff;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }

  .popup_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    background: #fff;

    .popup_button {
      width: 335px;
      height: 40px;
      max-width: 335px;
      /* 自动布局 */
      display: flex;
      justify-content: center;
      align-items: center;
      // padding: px 271px;
      border-radius: 8px;
      background: #1a66ff;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .popup_bt_lalst {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    margin-top: 20px;

    .popup_checkbox {
      color: rgba(0, 0, 0, 0.6) !important;
      font-size: 12px !important;
      width: 335px;
    }
  }
}

.van-tabbar {
  height: 80px !important;
}

::v-deep .mint-cell-title {
  width: 60px !important;
}

/* 如果仍然有上下边框，可以更明确地清除 */
::v-deep .mint-cell-wrapper {
  background: none !important;
}

::v-deep .mint-cell:last-child {
  background: none !important;
}

::v-deep .el-checkbox__label {
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 12px;
}
:deep(.html-content ol) {
  list-style-type: decimal;
  padding-left: 1.5em;
}
:deep(.html-content ul) {
  list-style-type: disc;
  padding-left: 1.5em;
}
:deep(.html-content li) {
  display: list-item;
}
:deep(.html-content h1) {
  font-size: 2em;
  font-weight: bold;
}
:deep(.html-content h2) {
  font-size: 1.5em;
  font-weight: bold;
}
:deep(.html-content h3) {
  font-size: 1.17em;
  font-weight: bold;
}
/* 以此类推... */
</style>
